import {OfferingFormPriceType} from "@/features/pricing";
import {GetProductApiResponse} from "../../../react-query-hooks/products/types";

/**
 * Reads a saved Digital Product's Pricing Model back in the form's own encoding.
 *
 * The wire states only Pay What You Want outright; Free and Single Fee stay derived from
 * whether the product is priced at all. Both the Pricing section and the Add-ons tab need
 * this answer, and a fourth Pricing Model should be a change in one place.
 *
 * @param product - the product as the edit pages hold it
 * @param isPwywEnabled - the feature flag; with it off, a product saved as Pay What You
 *   Want reads back as Single Fee, exactly as it did before this feature existed
 */
export function readDigitalProductPriceType(
  product: Pick<GetProductApiResponse, "product" | "currencies">,
  isPwywEnabled: boolean
): OfferingFormPriceType {
  if (product.currencies.length < 1) {
    return "free";
  }

  return isPwywEnabled && product.product.is_pay_what_you_want ? "pwyw" : "paid";
}
